import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'

/**
 * Mounts the WpGenerationBatch review + edit/publish Vue component (SP3
 * Task 10). The component itself owns data-fetching (GET show), per-page
 * edit/re-render (PATCH pages/:id), on-demand image generation (POST
 * pages/:id/generate_image), publish (individual + bulk), and the
 * ActionCable subscription for live generation progress -- this
 * controller's only job is the ERB -> Vue mount/unmount bridge. Mirrors
 * `wp_page_templates/review_controller.js` (SP2 Task 10).
 */
export default class extends Controller {
  static targets = ['loading']

  static values = {
    batchId: String,
    csrfToken: String
  }

  connect() {
    this.vueApp = null
    this.mountVue()
  }

  disconnect() {
    this.unmountVue()
  }

  async mountVue() {
    if (this.vueApp) return

    const { default: WpGenerationBatchReview } = await import('~/javascript/components/wp_generation_batches/review.vue')

    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = 'none'
    }

    const props = {
      batchId: this.batchIdValue,
      csrfToken: this.csrfTokenValue || document.querySelector('meta[name="csrf-token"]')?.content
    }

    this.vueApp = createApp(WpGenerationBatchReview, props)
    this.vueApp.mount(this.element)
  }

  unmountVue() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }
}
